import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Users,
  ShoppingCart,
  UserCheck,
  FileText,
  Home,
  Menu,
} from 'lucide-react';

interface CollapsedSidebarProps {
  onMenuClick: () => void;
}

const CollapsedSidebar: React.FC<CollapsedSidebarProps> = ({ onMenuClick }) => {
  const location = useLocation();

  const isActiveRoute = (path: string) => {
    return location.pathname === path;
  };

  const navigationItems = [
    {
      title: "Dashboard",
      path: "/dashboard",
      icon: Home,
    },
    {
      title: "Catalogue",
      path: "/catalogue",
      icon: FileText,
    },
    {
      title: "Patients", 
      path: "/patients",
      icon: Users,
    },
    {
      title: "Orders",
      path: "/orders", 
      icon: ShoppingCart,
    },
    {
      title: "Users",
      path: "/users",
      icon: UserCheck,
    },
    {
      title: "Reports",
      path: "/reports",
      icon: FileText,
    },
  ];

  return (
    <div className="hidden lg:flex fixed left-0 top-14 lg:top-16 bottom-0 w-16 bg-white border-r border-gray-200 flex-col items-center py-4 z-30 shadow-sm">
      <nav className="flex flex-col w-full">
        {/* Hamburger Menu Icon */}
        <div className="mb-4 pb-4 border-b border-gray-200">
          <div className="relative group">
            <button
              onClick={onMenuClick}
              className="flex items-center justify-center w-12 h-12 mx-auto rounded-lg transition-all duration-200 text-vitl-navy hover:bg-vitl-green/5 hover:text-vitl-green border-2 border-transparent"
              title="Menu"
            >
              <Menu className="w-5 h-5" />
            </button>
            
            {/* Tooltip */}
            <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-vitl-navy text-white text-sm px-2 py-1 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
              Menu
              <div className="absolute right-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-r-vitl-navy"></div>
            </div>
          </div>
        </div>

        {/* Navigation Icons */}
        <div className="flex flex-col space-y-2">
        {navigationItems.map((item) => {
          const Icon = item.icon;
          const isActive = isActiveRoute(item.path);
          
          return (
            <div key={item.path} className="relative group">
              <Link
                to={item.path}
                className={`flex items-center justify-center w-12 h-12 mx-auto rounded-lg transition-all duration-200 ${
                  isActive
                    ? 'bg-vitl-green/10 text-vitl-green border-2 border-vitl-green/20'
                    : 'text-vitl-navy hover:bg-vitl-green/5 hover:text-vitl-green border-2 border-transparent'
                }`}
                title={item.title}
              >
                <Icon className="w-5 h-5" />
              </Link>
              
              {/* Tooltip */}
              <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-vitl-navy text-white text-sm px-2 py-1 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                {item.title}
                <div className="absolute right-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-r-vitl-navy"></div>
              </div>
            </div>
          );
        })}
        </div>
      </nav>

      {/* Bottom branding */}
      <div className="mt-auto">
        <div className="w-12 h-12 flex items-center justify-center group cursor-pointer">
          <img 
            src="/small_logo.png" 
            alt="VITL" 
            className="h-8 w-8 object-contain opacity-60 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 ease-out group-hover:animate-pulse"
          />
        </div>
      </div>
    </div>
  );
};

export default CollapsedSidebar;